import { useContext } from "react"

import { StripeLoadingContext } from "@fuse/customProviders/StripeProvider"

/**
 * Hook to access Stripe loading state and retry functionality
 * Must be used within a StripeProvider
 */
export const useStripeLoading = () => {
  const context = useContext(StripeLoadingContext)

  if (!context) {
    throw new Error("useStripeLoading must be used within a StripeProvider")
  }

  return context
}
